import pick from 'object.pick';
import tracker from '../libs/tracker';
import underscorify from '../utils/underscorify';

const PERFORMANCE_EVENT_VERSION = 1;
const PERFORMANCE_ATTRIBUTES = ['navigationStart', 'unloadEventStart',
  'unloadEventEnd', 'redirectStart', 'redirectEnd', 'fetchStart',
  'domainLookupStart', 'domainLookupEnd', 'connectStart', 'connectEnd',
  'secureConnectionStart', 'requestStart', 'responseStart', 'responseEnd',
  'domLoading', 'domInteractive', 'domContentLoadedEventStart',
  'domContentLoadedEventEnd', 'domComplete', 'loadEventStart', 'loadEventEnd'
];

class PerformanceTracker {
  report() {
    const payload = pick(performance.timing, PERFORMANCE_ATTRIBUTES);
    tracker.trackBabbelTracker(
      'performance:page_loaded',
      PERFORMANCE_EVENT_VERSION,
      underscorify(payload)
    );
  }
}

export default new PerformanceTracker();
